import { useQuery } from '@tanstack/react-query'

import { supabase } from '@/lib/supabase/cliente'
import { mensajeDeError } from '@/lib/supabase/errores'
import type { EstadoDelTecnico } from '@/lib/supabase/tipos-bd'

/**
 * Dónde está cada técnico ahora mismo.
 *
 * Bajo la clave 'tablero': cualquier marca nueva (llegada, almuerzo, salida)
 * la refresca al instante por useOrdenesEnVivo. Y cada minuto se vuelve a
 * pedir, porque «fuera de la obra» o «no se sabe» cambian con la posición
 * del teléfono, no con una marca.
 */
export function useEstadoDelEquipo() {
  const consulta = useQuery({
    queryKey: ['tablero', 'estado-del-equipo'],
    refetchInterval: 60 * 1000,
    queryFn: async (): Promise<EstadoDelTecnico[]> => {
      const { data, error } = await supabase.rpc('fn_estado_del_equipo')
      if (error) throw new Error(mensajeDeError(error))
      return ((data ?? []) as unknown as EstadoDelTecnico[]).map((t) => ({
        ...t,
        distancia_m: t.distancia_m === null ? null : Number(t.distancia_m),
      }))
    },
  })

  return {
    tecnicos: consulta.data ?? [],
    cargando: consulta.isLoading,
    error: consulta.error?.message ?? null,
  }
}
